import { ValidateImportState } from '../../models';

export const validateImportInitialState: ValidateImportState = {
  amount: 0
};
